import AppLayout from './appLayout';

export default AppLayout;
